import React, {useState, useEffect} from 'react';
import { Button, StyleSheet, TextInput, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import api from '../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import Header from '../../../../navigation/Header';
import { ScrollView } from 'react-native-gesture-handler';
import IconButton from '../../../../components/IconButton';
import { FeeInfoBlock } from './PaymentCheckout/BankTransferPaymentScreen';
import { Image } from 'expo-image';
import useActiveResidentCommunity from '../../../../hooks/useActiveResidentCommunity';

import dayjs from 'dayjs';


function PaymentRow({payment}){
  const paymentDate = dayjs(payment.created_at)

  let statusColor = 'white'

  if(payment.status == "paid") statusColor = "primary"

  return (
    <View style={tw`bg-gray-100 py-5 px-5 rounded-xl`}>
      {
        payment.folio &&
          <View style={tw`row justify-between`}>
            <Text style={tw`text-base text-gray-400`}>Folio</Text>

            <Text style={tw`text-base text-gray-400 font-500`}>{payment.folio}</Text>
          </View>
      }

      <View style={tw`row justify-between`}>
        <Text style={tw`text-base text-gray-400`}>Monto</Text>

        <Text style={tw`text-base text-primary font-500`}>${payment.pivot.amount}</Text>
      </View>

      <View style={tw`row justify-between`}>
        <Text style={tw`text-base text-gray-400`}>Fecha de pago</Text>

        <Text style={tw`text-base text-black`}>{paymentDate.format('DD MMMM YYYY HH:mm')}</Text>
      </View>

      <View style={tw`row justify-between`}>
        <Text style={tw`text-base text-gray-400`}>Forma de pago</Text>

        <Text style={tw`text-base text-black`}>{payment.payment_method?.name}</Text>
      </View>

      <View style={tw`row justify-between`}>
        <Text style={tw`text-base text-gray-400`}>Estado</Text>

        <Text style={tw`text-base text-${statusColor} font-500`}>{payment.status_str}</Text>
      </View>

      <View style={tw`row justify-between`}>
        <Text style={tw`text-base text-gray-400`}>Referencia</Text>

        <Text style={tw`text-base text-gray-400`}>{payment.uuid.substr(-12)}</Text>
      </View>

    </View>
  )
}



export default function FeeUnitDetailScreen({navigation, route}) {
  const { unit_fee_id, unitId } = route.params
  const {communityId, community} = useActiveResidentCommunity()

  const { isLoading, error, data: feeUnit, refetch } = useQuery({
    queryKey: ['unit-fee.detail', communityId, unit_fee_id],
    queryFn: () => api.get(`/communities/${communityId}/unit-fees/${unit_fee_id}`).then(response => response.data),
  })

  
  //! Aquí se deberúa debería mandar a la pantalla de "Agregar cuotas"
  //! Ahorita manda directo a "Forma de pago" (que al momento es "Pagar transferncia" jaja)
  //! entonces esto de abajo es lo que se debería mandar desde "agregar cuotas"
  const goToPayment = () => navigation.navigate('Resident.UnitFeesPayment', { 
    communityId, 
    unitId,
    unit_fee_ids: [unit_fee_id], //!
    return_to_unit_fee_id: unit_fee_id,
    // advanced_fees_months //! Proposal para los pagos adelantados
    // onPaymentSucceed: refetch  //! << esto no pasar una función!
  })


  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      refetch()
    });

    return unsubscribe;
  }, [navigation]);

  
  const hasEvidences = (feeUnit?.evidences?.length > 0)
  const hasPayments = (feeUnit?.payments?.length > 0)
  const residentCanPayFees = (community?.settings?.fees?.resident_can_pay_fees)
  const feeCanBePaid = !hasEvidences && !feeUnit?.is_paid && residentCanPayFees

  // console.log(JSON.stringify(feeUnit?.evidences));
  

  return (
    <View style={tw`flex-1 bg-white `}>
      <View style={tw`bg-secondary rounded-b-2xl mb-6`}>
          <Header showBackButton backButtonColor='white' style={tw`bg-transparent mb-0 rounded-b-0`}>
          {
            isLoading &&
            <Text style={tw`text-white`}>Cargando...</Text>
          }
          {
            feeUnit &&
            <Text style={tw`text-lg text-white`}>{feeUnit.fee.name}</Text>
          }
          {/* <Text style={tw`text-xl text-white mt-0.5`}>Pagar adeudo</Text> */}
        </Header>

        <View style={tw` px-4`}>
          {
            feeUnit &&
              <FeeInfoBlock feeUnit={feeUnit} />

          }
        </View>
      </View>


      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`py-4 px-4`}>
        {
          feeUnit &&
            <View style={tw``}>

              {/* 
              
                Pagos 
              
              */}
              {
                hasPayments &&
                  <View style={tw`mb-6`}>
                    <Text style={tw`text-gray-700 font-500 mb-4 text-center`}>Pagos realizados</Text>

                    <View style={tw``}>
                      {
                        feeUnit.payments?.map(payment => 
                          <PaymentRow payment={payment} key={payment.uuid} />
                        )
                      }
                    </View>
                  </View>
              }

              {
                hasEvidences &&
                  <View style={tw`mb-6 bg-gray-100 py-4 px-5 rounded-lg`}>
                    <Text style={tw`text-gray-600 text-center text-lg mb-3`}>Comprobante de pago</Text>

                    <View style={tw``}>
                      {
                        feeUnit.evidences?.map(evidence => {
                          const evidenceDate = dayjs(evidence.created_at)

                          return (
                            <View style={tw``} key={evidence.uuid}>
                              <View style={tw`row justify-between`}>
                                <Text style={tw`text-gray-400`}>Fecha</Text>

                                <Text style={tw`text-gray-400`}>{evidenceDate.format('DD MMMM YYYY HH:mm')}</Text>
                              </View>

                              <View style={tw`row justify-between`}>
                                <Text style={tw`text-gray-400`}>Monto</Text>

                                <Text style={tw`text-gray-400`}>${evidence.amount}</Text>
                              </View>

                              <View style={tw`row justify-between`}>
                                <Text style={tw`text-gray-400`}>Estado</Text>

                                <Text style={tw`text-gray-400`}>{evidence.status_str}</Text>
                              </View>

                              <Image
                                source={evidence.images[0].url}
                                style={tw`w-full h-80 mt-4`}
                                contentFit='contain'
                              />
                            </View>
                          )
                        })
                      }
                    </View>

                </View>
              }

              {
                (feeCanBePaid) &&
                  <IconButton style={tw`py-3`}  title={'Pagar'} onPress={goToPayment} />
              }

              {/* TODO: recibo de pago */}
              {
                (false) &&
                  <IconButton title={'Descargar recibo de pago'} onPress={goToPayment} />
              }
            </View>
        }
      </ScrollView>
    </View>
  );
}
